import React, { Component } from "react";
import { Col, Row } from "react-flexbox-grid";
import { CardColor, Loader } from "ui-kit-ck-consultant";

import axiosConfig from "../../../utils/axiosConfig";
import WidgetWrapper from "./WidgetWrapper";

export default class WidgetAlerts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoad: true,
      data: null,
    };
  }

  componentDidMount() {
    axiosConfig("alert/get-data-precisia-pilotage").then((res) => {
      if (res.data.success) {
        this.setState({ data: res.data.data, isLoad: false });
      } else {
        this.setState({ isLoad: false });
      }
    }).catch(() => {
      this.setState({ isLoad: false });
    });
  }

  render() {
    const { data, isLoad } = this.state;

    let alertCount = 0;
    let riskCount = 0;

    if (data) {
      if (Array.isArray(data)) {
        alertCount = data.length;
      } else {
        alertCount = data.alerts || 0;
        riskCount = data.risks || 0;
      }
    }

    return (
      <WidgetWrapper
        title="Alertes"
        isCustomizing={this.props.isCustomizing}
        dragHandleProps={this.props.dragHandleProps}
        onHide={this.props.onHide}
      >
        {isLoad ? (
          <Loader />
        ) : (
          <Row>
            <Col xs={12} md={6}>
              <CardColor
                title="Alertes actives"
                count={alertCount}
                className={`mb-10 ${alertCount === 0 ? "bg-green" : "bg-orange"}`}
              />
            </Col>
            <Col xs={12} md={6}>
              <CardColor
                title="Indicateurs de risque"
                count={riskCount}
                className={`mb-10 ${riskCount === 0 ? "bg-green" : "bg-red"}`}
              />
            </Col>
          </Row>
        )}
      </WidgetWrapper>
    );
  }
}
